import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/secured-api/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class EntitlementGuard implements CanActivate {
  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate(): Observable<boolean | UrlTree> {

    return this.authenticationService.isUserHasReadPermission().pipe(
      map(hasAccess => {
        if (hasAccess) {
          return true;
        } else {
          // Redirect to an unauthorized page
          return this.router.createUrlTree(['/unauthorized']);
        }
      })
    );
  }
}
